module.exports = __webpack_public_path__ + "img/centrifuge-B-shadow.9bda5587.png";